
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin';
import 'swiper/css/swiper.css';

export default BaseCmsBlock.extend({
    name: 'PublicSpaceSectionBlock',

    data() {
        const vnode = (Math.random() + 1).toString(36).substring(7);
        return {
            swiperOptions: {
                spaceBetween: 30,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: true,

                navigation: {
                    prevEl: `#button-navigation-${vnode}-prev`,
                    nextEl: `#button-navigation-${vnode}-next`,
                },
            },

            activeSlide: 0,

            vnode,
        };
    },

    components: {
        Swiper,
        SwiperSlide,
    },

    methods: {
        openPopUpImages() {
            const activeIndex = this.$refs.refSwiper?.$swiper?.realIndex || 0;
            this.$store.commit('pop-up-images/setImages', {
                images: (this.values.images || []).map((t) => t.image),
                parametrs: {
                    activeIndex,
                },
            });
        },

        slideChange() {
            this.activeSlide = this.$refs.refSwiper?.$swiper?.realIndex || 0;
        },
        setSlide(index) {
            this.$refs.refSwiper.$swiper.slideToLoop(index);
        },
    },
});
